import React, { Component } from 'react';
import { EconomicalScoreTrackerPlayer } from '../stateless/eco-score-player';
import { connect } from 'react-redux';
import { buildAvatar } from '../../helpers';
import { players } from '../../constants/images';

/**
 * @class EconomicalScoreTracker
 *
 * @description
 * Class for.
 *
 * @example
 * <EconomicalScoreTracker />
 */
@connect(
	state => {
		const avatar = state.results.saveState ? state.results.saveState.avatar : { options: [] };
		return {
			avatarOptions: avatar && avatar.options ? avatar.options : null,
			step: state.step,
			results: state.results
		}
	}
)
export default class ReviewResultsPlainText extends Component {

	static propTypes = {};

	static defaultProps = {};

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { playersResults } = this.props;
		const playerAvatar = buildAvatar(this.props, false);

		return (playersResults) ? (
			<div className={'eco-score-tracker__review'}>

				<EconomicalScoreTrackerPlayer score={playersResults['player-1']}
																			imgSrc={playerAvatar} />
				<EconomicalScoreTrackerPlayer score={playersResults['player-2']}
																			imgSrc={players['player-2']} />
				<EconomicalScoreTrackerPlayer score={playersResults['player-3']}
																			imgSrc={players['player-3']} />
				<EconomicalScoreTrackerPlayer score={playersResults['player-4']}
																			imgSrc={players['player-4']} />

			</div>
		) : null;
	}
}
